import { render, staticRenderFns } from "./EditCompanyInfoModal.vue?vue&type=template&id=66de0670&"
import script from "./EditCompanyInfoModal.vue?vue&type=script&lang=js&"
export * from "./EditCompanyInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports